import request from "@/plugin/axios";
// 首页轮播
export function getBannerList() {
  return request({
    url: "/MobileApis/BannerSettingsHandler.ashx?action=Query",
    method: "get",
  });
}

export function getSwipeList(action, data) {
  return request({
    url: action,
    method: "POST",
    data: data,
    loading: {
      type: "nprogress",
      interval: 500,
    },
  });
}

// 列表跳转获取详情
export function getWebView(data) {
  return request({
    url: "/MobileApis/DataHandler.ashx?action=GetFormData",
    method: "POST",
    data: data,
    loading: {
      type: "nprogress",
      interval: 500,
    },
  });
}

// 列表跳转获取是否可以评论
export function getUserCanSpeak(data) {
  return request({
    url:
      "/MobileApis/CommentHandler.ashx?action=GetUserCanSpeak",
    method: "POST",
    data: data,
    loading: {
      type: "nprogress",
      interval: 500,
    },
  });
}

// 列表跳转获取评价量
export function GetDZCount(data) {
  return request({
    url: "/MobileApis/CommentHandler.ashx?action=GetDZCount",
    method: "POST",
    data: data,
    loading: {
      type: "nprogress",
      interval: 500,
    },
  });
}

// 列表跳转获取评价列表
export function GetCommentList(data) {
  return request({
    url: "/MobileApis/CommentHandler.ashx?action=Query",
    method: "POST",
    data: data,
    loading: {
      type: "nprogress",
      interval: 500,
    },
  });
}

// list 列表
export function getActiveDataList(action, data) {
  return request({
    url: action,
    method: "POST",
    data: data,
    loading: {
      type: "nprogress",
      interval: 500,
    },
  });
}

// 我要提问
export function addQuestionData(data) {
  return request({
    url: "/MobileApis/DataHandler.ashx?action=SaveData",
    method: "POST",
    data: data,
  });
}

// 列表详情
export function getActiveDetialData(data) {
  return request({
    url: "/MobileApis/DataHandler.ashx?action=GetFormData",
    method: "POST",
    data: data,
  });
}

// 同意
export function getAgreeData(data) {
  return request({
    url: "/MobileApis/CommentHandler.ashx?action=Agree",
    method: "POST",
    data: data,
  });
}

// 添加评论
export function AddCommentData(data) {
  return request({
    url: "/MobileApis/CommentHandler.ashx?action=AddComment",
    method: "POST",
    data: data,
  });
}

// 是否有回复权限
export function getReplyPermission(data) {
  return request({
    url:
      "/MobileApis/DataHandler.ashx?action=GetMayProcessItems",
    method: "POST",
    data: data,
  });
}

// 查看
export function IsReadListData(data) {
  return request({
    url:
      "/MobileApis/DataHandler.ashx?action=InsertFormDataIsRead",
    method: "POST",
    data: data,
  });
}

//回复
export function addReplayData(data) {
  return request({
    url: "/MobileApis/ActivityShareHandler.ashx?action=Reply",
    method: "POST",
    data: data,
  });
}

// 活动**************************************************************************************************
//活动详情
export function GetActivityDetail(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=GetActivityDetail",
    method: "POST",
    data: data,
  });
}

//活动
export function IsInBlackList(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=IsInBlackList",
    method: "POST",
    data: data,
  });
}

//
export function GetSignUpInfo(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=GetSignUpInfo",
    method: "POST",
    data: data,
  });
}

//  职代会热点权限
export function GetUnionHotConfig(data) {
  return request({
    url: "/MobileApis/UnionHotHandler.ashx?action=GetUnionHotConfig",
    method: "POST",
    data: data,
  });
}

// 福利**************************************************************************************************
// 是否会员
export function GetIsMember(data) {
  return request({
    url: "/MobileApis/MemberHandler.ashx?action=IsMember",
    method: "POST",
    data: data,
  });
}

// 申请次数
export function GetWelfareApplyStatus(data) {
  return request({
    url:
      "/MobileApis/WelfareHandler.ashx?action=GetWelfareApplyStatus",
    method: "POST",
    data: data,
  });
}

// 上传文件 有水印
export function uploadFile(data, name) {
  return request({
    url: "/MobileApis/UploadFile3.aspx?filename=" + name,
    method: "post",
    data: data,
  });
}

//无水印
export function uploadFileNo(data, name) {
  return request({
    url: "/MobileApis/UploadFile6.aspx?filename=" + name,
    method: "post",
    data: data,
  });
}

// 是否可申请补助
export function GetSubsidyApplyStatus(data) {
  return request({
    url:
      "/MobileApis/WelfareHandler.ashx?action=GetSubsidyApplyStatus",
    method: "post",
    data: data,
  });
}

// 疾病种类
export function GetDiseaseType(data) {
  return request({
    url:
      "/MobileApis/DataHandler.ashx?action=GetFormDataList",
    method: "post",
    data: data,
  });
}

// 家属信息列表
export function GetFamilyInfo(data) {
  return request({
    url:
      "/MobileApis/MemberApplyHandler.ashx?action=GetFamilyInfo",
    method: "post",
    data: data,
  });
}

// 任务**************************************************************************************************
//
export function GetRootConfigValue(data) {
  return request({
    url: "/MobileApis/MobileHandler.ashx?action=GetRootConfigValue",
    method: "post",
    data: data,
  });
}

// 补助类型
export function GetSubsidyType(data) {
  return request({
    url: "/MobileApis/WelfareHandler.ashx?action=GetSubsidyType",
    method: "post",
    data: data,
  });
}

// 流程
export function GetWorkflowRecord(data) {
  return request({
    url: "/MobileApis/Project/DataHandler.ashx?action=GetWorkflowRecord",
    method: "post",
    data: data,
  });
}

//  消息**************************************************************************************************
// 已读
export function SetAllRead() {
  return request({
    url: "/MobileApis/PersonalMessageHandler.ashx?action=SetAllRead",
    method: "post",
  });
}

// 查看消息
export function GetMsgData(data) {
  return request({
    url: "/MobileApis/PersonalMessageHandler.ashx?action=GetMsgData",
    method: "post",
    data: data,
  });
}

// 城市列表
export function GetCityData1(data) {
  return request({
    url: "/MobileApis/MemberHandler.ashx?action=GetCityData1",
    method: "post",
    data: data,
  });
}

// 新单子时获取自动获取数据的方法
export function GetMemberInfo(data) {
  return request({
    url:
      "/MobileApis/MemberHandler.ashx?action=GetMemberInfo",
    method: "post",
    data: data,
  });
}

// 获取原来的单子
export function GetMemberChange(data) {
  return request({
    url:
      "/MobileApis/MemberChangeHandler.ashx?action=GetMemberChange",
    method: "post",
    data: data,
  });
}

// 预备会员 状态
export function GetMemberApplyStatus(data) {
  return request({
    url:
      "/MobileApis/MemberApplyHandler.ashx?action=GetMemberApplyStatus",
    method: "post",
    data: data,
  });
}

// 获取原来单子的方法
export function GetMemberApply(data) {
  return request({
    url:
      "/MobileApis/MemberApplyHandler.ashx?action=GetMemberApply",
    method: "post",
    data: data,
  });
}

//申请入会
export function AddMemberApply(data) {
  return request({
    url:
      "/MobileApis/MemberApplyHandler.ashx?action=AddMemberApply",
    method: "post",
    data: data,
  });
}

// 申请入会修改
export function UpdateMemberApply(data) {
  return request({
    url:
      "/MobileApis/MemberChangeHandler.ashx?action=UpdateMemberApply",
    method: "post",
    data: data,
  });
}

//小组信息
export function GetGroupManager(data) {
  return request({
    url:
      "/MobileApis/AppUserHandler.ashx?action=GetGroupManager",
    method: "post",
    data: data,
  });
}

//增加修改会员信息
export function AddMemberChange(data) {
  return request({
    url:
      "/MobileApis/MemberChangeHandler.ashx?action=AddMemberChange",
    method: "post",
    data: data,
  });
}

//会员加催
export function AddUrgentMessage(data) {
  return request({
    url:
      "/MobileApis/SendMessageHandler.ashx?action=AddUrgentMessage",
    method: "post",
    data: data,
  });
}

//撤销申请
export function DischargePetition(data) {
  return request({
    url: "/MobileApis/Project/DataHandler.ashx?action=InvalidForm",
    method: "post",
    data: data,
  });
}

//加崔中
export function GetUrgentStatus(data) {
  return request({
    url:
      "/MobileApis/SendMessageHandler.ashx?action=GetUrgentStatus",
    method: "post",
    data: data,
  });
}

// 积分
export function GetBalance(data) {
  return request({
    url: "/MobileApis/WalletBillHandler.ashx?action=GetBalance",
    method: "post",
    data: data,
  });
}

// 代金券
export function GetMoneyBalanceForUser(data) {
  return request({
    url:
      "/MobileApis/WalletBillHandler.ashx?action=GetMoneyBalanceForUser",
    method: "post",
    data: data,
  });
}

// 代金券
export function GetMonthConsume(data) {
  return request({
    url: "/MobileApis/WalletBillHandler.ashx?action=GetMonthConsume",
    method: "post",
    data: data,
  });
}

// 删除
export function DeleteUnionHot(data) {
  return request({
    url: "/MobileApis/UnionHotHandler.ashx?action=Delete",
    method: "post",
    data: data,
  });
}

// *********************************************************************************************
// 代表名单 搜索筛选
export function GetSearchList(data) {
  return request({
    url:
      "/MobileApis/DataHandler.ashx?action=GetAllFormDataList",
    method: "post",
    data: data,
  });
}

// 消息已读
export function UpMsgIsRead(data) {
  return request({
    url: "MobileApis/PersonalMessageHandler.ashx?action=UpMsgIsRead",
    method: "post",
    data: data,
  });
}

//跳转jd
export function JumpJD(uid) {
  return request({
    url:
      "MobileApis/RedirectToJDJfdPage.ashx?uid=" +
      uid +
      "&type=pc",
    method: "get",
  });
}

//跳转百福得
export function JumpBfd(uid) {
  return request({
    url:
      "MobileApis/BfdHandler.ashx?action=GetLoginParameter&type=pc",
    method: "post",
    data: { ad: uid },
  });
}
//跳转百福得
export function JumpDyf() {
  return request({
    url:
      "MobileApis/DyfHandler.ashx?action=GetLoginParameter",
    method: "post",
    data: { },
  });
}

//捐赠
export function SavePresent(data) {
  return request({
    url: "/MobileApis/WalletBillHandler.ashx?action=SavePresent",
    method: "post",
    data: data,
  });
}

//活动信息
export function GetActivityInfo(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=GetActivityInfo",
    method: "post",
    data: data,
  });
}

export function GetInvitee(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=GetInvitee",
    method: "post",
    data: data,
  });
}

export function GetFileName(data) {
  return request({
    url: "/MobileApis/FileManagerHandler.ashx?action=GetLocalFile",
    method: "post",
    data: data,
  });
}

//报名代金券金额
export function MobileIndexGetUserCardValue(data) {
  return request({
    url:
      "/MobileApis/CommonHandler.ashx?action=MobileIndexGetUserCardValue",
    method: "post",
    data: data,
  });
}

// 提交报名
export function GetSubstituteCount(data) {
  return request({
    url:
      "/MobileApis/ActivityHandler.ashx?action=GetSubstituteCount",
    method: "post",
    data: data,
  });
}

// 签到成功提示
export function SignUp(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=SignUp",
    method: "post",
    data: data,
  });
}

//修改报名
export function SignUpModify(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=SignUpModify",
    method: "post",
    data: data,
  });
}

//
export function SignUpDetail(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=SignUpDetail",
    method: "post",
    data: data,
  });
}

// 取消报名
export function CancelSignUp(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=CancelSignUp",
    method: "post",
    data: data,
  });
}

// 取消报名 取消预约
export function CancelSignUpCourse(data) {
  return request({
    url:
      "/MobileApis/ActivityHandler.ashx?action=CancelSignUpCourse",
    method: "post",
    data: data,
  });
}

// 切换地址
export function ModifyReceiverInfo(data) {
  return request({
    url:
      "/MobileApis/ActivityHandler.ashx?action=ModifyReceiverInfo",
    method: "post",
    data: data,
  });
}

// 住宿搭档列表
export function GetSignUpList(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=GetSignUpList",
    method: "post",
    data: data,
  });
}

// 退回审核
export function ProcessWorkflowAction(data) {
  return request({
    url:
      "/MobileApis/DataHandler.ashx?action=ProcessWorkflowAction",
    method: "post",
    data: data,
  });
}

// ***************************************************************************************************
// 在线
export function GetQuestionType() {
  return request({
    url: "/MobileApis/QuestionHandler.ashx?action=GetQuestionType",
    method: "post",
  });
}

//搜索内容
export function GetQuestionList(data) {
  return request({
    url: "/MobileApis/QuestionHandler.ashx?action=Query",
    method: "post",
    data: data,
  });
}

export function JdPayGetData(data) {
  return request({
    url: "/MobileApis/JDJfd/GetOrderData.ashx?orderId=" + data,
    method: "get",
  });
}

export function JdPayValidJdUser(data) {
  return request({
    url: "/WebApis/LoginHandler.ashx?action=ValidJdUser",
    method: "post",
    data: data,
    NoShow: true,
  });
}

export function JdPayJinDongPayment(data) {
  return request({
    url:
      "/MobileApis/WalletBillHandler.ashx?action=JinDongPayment&orderId=" +
      data.orderId,
    method: "get",
  });
}

// 报名活动填写备注
export function GetSignUpRemark(data) {
  return request({
    url: "/MobileApis/ActivityHandler.ashx?action=GetSignUpRemark",
    method: "post",
    data: data,
  });
}

// 报名活动新增或修改备注
export function SetSignUpRemark(data) {
  return request({
    url: "MobileApis/ActivityHandler.ashx?action=SetSignUpRemark",
    method: "post",
    data: data,
  });
}

export function BfdPayGetData(data) {
  return request({
    url: "/MobileApis/BfdHandler.ashx?action=GetOrderGoodsList&paymentSn=" + data,
    method: "get",
  });
}

//百福得付款相关
export function BfdPayPayment(data) {
  return request({
    url:"/MobileApis/WalletBillHandler.ashx?action=BfdPayment&orderId=" + data.orderId + "&paymentSn=" + data.paymentSn,
    method: "get",
  });
}

// 积分汇总
export function IntegralStatisticsByUser(data) {
  return request({
    url:"/MobileApis/WalletBillHandler.ashx?action=IntegralStatisticsByUser",
    method: "post",
    data: data,
  });
}

// 积分转赠
export function CheckCanGift() {
  return request({
    url:"/MobileApis/WalletBillHandler.ashx?action=CheckCanGift",
    method: "post",
  });
}
export function GetUserInfoForAdAccount(data) {
  return request({
    url:"/MobileApis/WalletBillHandler.ashx?action=GetUserInfoForAdAccount",
    method: "post",
    data: data,
  });
}
export function GiftAmountToAdAccount(data) {
  return request({
    url:"/MobileApis/WalletBillHandler.ashx?action=GiftAmountToAdAccount",
    method: "post",
    data: data,
  });
}

// 退出登录
export function Logout(data) {
  return request({
    url:"/WebApis/LoginHandler.ashx?action=Logout",
    method: "post",
    data: data,
  });
}

// 所属小组
export function GetGroupByUser(data) {
  return request({
    url:"/MobileApis/MemberApplyHandler.ashx?action=GetGroupByUser",
    method: "post",
    data: data,
  });
}
